import { Flex, Icon, ImgProps } from '@wyz/ui';
import * as React from 'react';
import { useConfig } from '~/common/context';
import { Img } from '~/purchase/components';
import clsx from 'clsx';

type ImageSlideProps = {
  images: Array<
    Pick<
      ImgProps,
      'defaultImage' | 'pathResolver' | 'src' | 'width' | 'height' | 'baseUrl'
    >
  >;
};
const ImageSlide = ({ images }: ImageSlideProps) => {
  const [selected, setSelected] = React.useState(0);
  const { apiUrl } = useConfig();
  return (
    <div className='d-flex flex-column h-100'>
      <Flex className='flex-grow-1' alignItems='center' justifyContent='center'>
        <Img
          height={360}
          baseUrl={apiUrl}
          {...images[selected]}
          loader={() => <Icon icon='spinner' size='lg' />}
        />
      </Flex>
      {images.length > 1 && (
        <Flex
          className='space-x-2 mt-3'
          alignItems='center'
          justifyContent='center'
        >
          {images.map((image, index) => (
            <div
              key={index}
              className={clsx('border border-1', {
                'border-dark': index === selected,
              })}
            >
              <Img
                baseUrl={apiUrl}
                {...image}
                width={80}
                height={80}
                onClick={() => setSelected(index)}
                loader={({ height, width }) => (
                  <Icon icon='spinner' height={height} width={width} />
                )}
              />
            </div>
          ))}
        </Flex>
      )}
    </div>
  );
};

export default ImageSlide;
